module.exports = __webpack_public_path__ + "static/media/the-good-fight-desktop-header.f58d189b.jpg";